import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  getDoc,
  getDocs,
  query,
  updateDoc,
  where
} from 'firebase/firestore';
import { auth, db } from './firebase.js';

    

    export const fetchUserDocumentId = async (userUID) => {
        const usersCollection = collection(db, 'users');
        const userQuery = query(usersCollection, where('uid', '==', userUID));
        const querySnapshot = await getDocs(userQuery);
        if (!querySnapshot.empty) {
            const userDocumentId = querySnapshot.docs[0].id;
            return userDocumentId;
        }
        return null;
    };
  
  export const fetchSavedRecipes = async (userDocumentId) => {
    if (!userDocumentId) {
      return [];
    }
    const savedRecipesCollection = collection(
      db,
      'users',
      userDocumentId,
      'savedRecepties'
    );
    const savedRecipesQuery = await getDocs(savedRecipesCollection);
  
    if (!savedRecipesQuery.empty) {
      const savedRecipes = savedRecipesQuery.docs.map(async (doc) => {
        const recipeDocRef = doc.data().Recipe;
        const recipeDocSnapshot = await getDoc(recipeDocRef);
        if (recipeDocSnapshot.exists()) {
          const recipeData = recipeDocSnapshot.data();
          const authorDocRef = recipeData.author;
          const authorDocSnapshot = await getDoc(authorDocRef);
          if (authorDocSnapshot.exists()) {
            const authorData = authorDocSnapshot.data();
            
            return {
                id: recipeDocRef.id,
              ...recipeData,
              author: authorData,
            };
          }
        }
        return null;
      });
      return Promise.all(savedRecipes);
    }
    return [];
  };

  // delete recipe by id
  export const deleteRecipe = async (recipeId) => {
    try {
      // Check if the user is authenticated
      const user = auth.currentUser;
      if (!user) {
        throw new Error('You must be logged in to delete a recipe');
      }
      let recipesCollection = collection(db,'Recpies')
      const recipeDocRef = doc(db, 'Recpies', recipeId);
      await deleteDoc(recipeDocRef);
      console.log('Recipe deleted successfully');
      return true; // Return true to indicate success
    } catch (error) {
      console.error('Error deleting recipe:', error);
      return false; // Return false to indicate failure
    }
  };


  
// Save a recipe to the user's savedRecipes collection
export const saveRecipe = async ({ recipe }) => {
  try {
    // Check if the user is authenticated
    const user = auth.currentUser;
    if (!user) {
      throw new Error('You must be logged in to save a recipe');
    }

    // Fetch the user's document ID
    const userDocumentId = await fetchUserDocumentId(user.uid);

    if (!userDocumentId) {
      throw new Error('User document ID not found');
    }

    // Reference to the user's savedRecipes collection
    const savedRecipesCollection = collection(
      db,
      'users',
      userDocumentId,
      'savedRecepties'
    );


    // get recipe refrence
    const recipeDocRef = doc(db, 'Recpies', recipe.id);


    // Check if the recipe is already saved
    const existingRecipeQuery = query(
      savedRecipesCollection,
      where('Recipe', '==', recipeDocRef)
    );

    const existingRecipeSnapshot = await getDocs(existingRecipeQuery);

    if (!existingRecipeSnapshot.empty) {
      throw new Error('Recipe already saved');
    }

    // Add the recipe reference to the user's savedRecipes collection
    await addDoc(savedRecipesCollection, {
      Recipe: recipeDocRef, // Assuming you're storing a reference to the recipe document
    });

    console.log('Recipe saved successfully');
    return true; // Return true to indicate success
  } catch (error) {
    console.error('Error saving recipe:', error);
    return false; // Return false to indicate failure
  }
};

// Unsave a recipe from the user's savedRecipes collection
export const unsaveRecipe = async ({ recipe }) => {
  try {
    // Check if the user is authenticated
    const user = auth.currentUser;
    if (!user) {
      throw new Error('You must be logged in to unsave a recipe');
    }

    // Fetch the user's document ID
    const userDocumentId = await fetchUserDocumentId(user.uid);

    if (!userDocumentId) {
      throw new Error('User document ID not found');
    }

    // Reference to the user's savedRecipes collection
    const savedRecipesCollection = collection(
      db,
      'users',
      userDocumentId,
      'savedRecepties'
    );

    // Get the recipe reference
    const recipeDocRef = doc(db, 'Recpies', recipe.id);

    // Query to find the saved recipe document with the specified reference
    const savedRecipeQuery = query(
      savedRecipesCollection,
      where('Recipe', '==', recipeDocRef)
    );

    const savedRecipeSnapshot = await getDocs(savedRecipeQuery);

    if (savedRecipeSnapshot.empty) {
      throw new Error('Recipe is not saved');
    }

    // Delete the saved recipe document to unsave the recipe
    const savedRecipeDoc = savedRecipeSnapshot.docs[0];
    await deleteDoc(savedRecipeDoc.ref);

    console.log('Recipe unsaved successfully');
    return true; // Return true to indicate success
  } catch (error) {
    console.error('Error unsaving recipe:', error);
    return false; // Return false to indicate failure
  }
};



export const getRecipeByUserId = async (userId) => {
  const userCollection = collection(db, 'users');
  const userQuery = query(userCollection, where('uid', '==', userId));
  const userSnapshot = await getDocs(userQuery);

  if (!userSnapshot.empty) {
    // author field is a refrense to a user
    const userDocRef = userSnapshot.docs[0].ref;
    const recipesCollection = collection(db, 'Recpies'); // Replace with your collection name
    const recipesQuery = query(recipesCollection, where('author', '==', userDocRef));
    const recipesSnapshot = await getDocs(recipesQuery);

    if (!recipesSnapshot.empty) {
      const recipes = recipesSnapshot.docs.map(async (recipeDoc) => {
        const recipeData = recipeDoc.data();
        const authorDocRef = recipeData.author;
        const authorDocSnapshot = await getDoc(authorDocRef);

        if (authorDocSnapshot.exists()) {
          const authorData = authorDocSnapshot.data();
          return {
            id: recipeDoc.id,
            ...recipeData,
            author: authorData,
          };
        }

        return null;
      });

      return Promise.all(recipes);
    }
  }

  return [];
};


  export const fetchRecipeDetails = async (recipeId) => {
    const recipeDocRef = doc(db, 'Recpies', recipeId); 
    const recipeDocSnapshot = await getDoc(recipeDocRef);
  
    if (recipeDocSnapshot.exists()) {
        const recipeData = recipeDocSnapshot.data();
        const authorDocRef = recipeData.author;
        const authorDocSnapshot = await getDoc(authorDocRef);
        if (authorDocSnapshot.exists()) {
            const authorData = authorDocSnapshot.data();
            return {
                id: recipeId,
                ...recipeData,
                author: authorData,
            };
        }
    }
    return null;
  };

  // createRecipe
export const createRecipe = async (recipe) => {
  const user = auth.currentUser;
  if (!user) {
    throw new Error('You must be logged in to create a recipe');
  }
  // get user ref
  const userDocumentId = await fetchUserDocumentId(auth.currentUser.uid);
  const userDocRef = doc(db, 'users', userDocumentId);
  recipe.author = userDocRef;

  const recipeCollection = collection(db, 'Recpies');
  await addDoc(recipeCollection, {
    ...recipe
    });
  console.log('Recipe created successfully');
};


  // updateRecipe
  export const updateRecipe = async (recipeId, recipeData) => {
    console.log(
      `Updating recipe with ID ${recipeId} with the following data:`,
    )
    console.log(recipeData);

    const recipeRef = doc(db, 'Recpies', recipeId);

    try {
      // get user ref
      const userDocumentId = await fetchUserDocumentId(auth.currentUser.uid);
      const userDocRef = doc(db, 'users', userDocumentId);
      recipeData.author = userDocRef;
      await updateDoc(recipeRef, recipeData);
      console.log(`Recipe with ID ${recipeId} updated successfully.`);
      return true; // Return true to indicate success
    } catch (error) {
      console.error(`Error updating recipe with ID ${recipeId}:`, error);
      return false; // Return false to indicate failure
    }
  };

  // fetch all recipes that are vegan
  export const fetchVeganRecipes = async () => {
    const recipesCollection = collection(db, 'Recpies'); 
    const veganQuery = query(recipesCollection, where('vegan', '==', true));
    const recipesQuery = await getDocs(veganQuery);
    if (!recipesQuery.empty) {
      const allRecipes = recipesQuery.docs.map(async (doc) => {
        const recipeData = doc.data();
        const authorDocRef = recipeData.author;
        const authorDocSnapshot = await getDoc(authorDocRef);
        if (authorDocSnapshot.exists()) {
          const authorData = authorDocSnapshot.data();
          return {
            id: doc.id,
            ...recipeData,
            author: authorData,
          };
        }
        return null;
      });
      return Promise.all(allRecipes);
    }
    return [];
  };

  

  export const fetchAllRecipes = async () => {
    const recipesCollection = collection(db, 'Recpies'); 
    const recipesQuery = await getDocs(recipesCollection);
    if (!recipesQuery.empty) {
      const allRecipes = recipesQuery.docs.map(async (doc) => {
        const recipeData = doc.data();
        const authorDocRef = recipeData.author;
        const authorDocSnapshot = await getDoc(authorDocRef);
        if (authorDocSnapshot.exists()) {
          const authorData = authorDocSnapshot.data();
          return {
            id: doc.id,
            ...recipeData,
            author: authorData,
          };
        }
        return null;
      });
      return Promise.all(allRecipes);
    }
    return [];
  };

  // Fetch reviews for a recipe
  export const fetchRecipeReviews = async (recipeId) => {
    try {
      const reviewsCollection = collection(db, 'Recpies', recipeId, 'reviews');
      const reviewsQuery = await getDocs(reviewsCollection);
      
      if (!reviewsQuery.empty) {
        const reviews = reviewsQuery.docs.map(async (doc) => {
          const reviewData = doc.data();
          const userDocRef = reviewData.user;
          const userDocSnapshot = await getDoc(userDocRef);
          
          return {
            id: doc.id,
            ...reviewData,
            userName: userDocSnapshot.exists() ? userDocSnapshot.data().name : 'Anonymous',
            userPhoto: userDocSnapshot.exists() ? userDocSnapshot.data().photoURL : null,
          };
        });
        
        return Promise.all(reviews);
      }
      return [];
    } catch (error) {
      console.error('Error fetching reviews:', error);
      return [];
    }
  };

  // Add a new review to a recipe
  export const addRecipeReview = async (recipeId, { rating, reviewText }) => {
    try {
      const user = auth.currentUser;
      if (!user) {
        throw new Error('You must be logged in to leave a review');
      }

      const userDocRef = doc(db, 'users', await fetchUserDocumentId(user.uid));
      
      const reviewsCollection = collection(db, 'Recpies', recipeId, 'reviews');
      const newReview = await addDoc(reviewsCollection, {
        rating: parseInt(rating),
        reviewText: reviewText || '',
        user: userDocRef,
        dateAdded: new Date(),
      });

      return newReview.id;
    } catch (error) {
      console.error('Error adding review:', error);
      throw error;
    }
  };

  // Fetch user profile and their recipes
  export const fetchUserProfile = async (userUID) => {
    try {
      const usersCollection = collection(db, 'users');
      const userQuery = query(usersCollection, where('uid', '==', userUID));
      const querySnapshot = await getDocs(userQuery);
      
      if (querySnapshot.empty) {
        throw new Error('User not found');
      }

      const userData = querySnapshot.docs[0].data();

      // Fetch recipes created by this user
      const recipesCollection = collection(db, 'Recpies');
      const userRef = querySnapshot.docs[0].ref;
      const recipesQuery = query(recipesCollection, where('author', '==', userRef));
      const recipesSnapshot = await getDocs(recipesQuery);

      const userRecipes = recipesSnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      return {
        ...userData,
        uid: userUID,
        recipes: userRecipes,
      };
    } catch (error) {
      console.error('Error fetching user profile:', error);
      throw error;
    }
  };


